import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';
import 'dayjs/locale/pt-br';
import 'dayjs/locale/en';

const DAYJS_LOCALE_MAP: Record<string, string> = {
  'pt-BR': 'pt-br',
  en: 'en',
};

/**
 * Syncs the current i18n language with dayjs locale and
 * provides the current language for components that need it.
 */
export function useLocale() {
  const { i18n } = useTranslation();
  const currentLanguage = i18n.language || 'pt-BR';

  useEffect(() => {
    const dayjsLocale = DAYJS_LOCALE_MAP[currentLanguage] || 'pt-br';
    dayjs.locale(dayjsLocale);
  }, [currentLanguage]);

  return {
    language: currentLanguage,
    isPortuguese: currentLanguage === 'pt-BR',
    isEnglish: currentLanguage === 'en',
    dateLocale: DAYJS_LOCALE_MAP[currentLanguage] || 'pt-br',
  };
}
